<div class="category-home">
  <div class="category-container">
    <ul class="ct-breadcrumbs">
      <li>
        <a href="">Home</a>
      </li>
      <li>
        <a *ngIf="!isSymptom" [routerLink]="['/' + groupName]">{{groupName | slugText : 'capitalize'}}</a>
        <a *ngIf="isSymptom" [routerLink]="['/health-conditions']">Health Conditions</a>
      </li>
      <li *ngIf="isSubCategoryPage">
        <a [routerLink]="['/category/' + mainCategory]">{{mainCategory | slugText : 'capitalize'}}</a>
      </li>
      <ng-container *ngIf="hasCity; else cityViewTemplate">
        <li>
          <a [routerLink]="[(isSubCategoryPage ? '/category/' + mainCategory : '/category') + '/' + category]">{{category | slugText : 'capitalize'}}</a>
        </li>
        <ng-container *ngIf="hasCity">
          <li>
            <p>{{city | slugText : 'capitalize'}}</p>
          </li>
        </ng-container>
      </ng-container>
      <ng-template #cityViewTemplate>
        <li>
          <p>{{category | slugText : 'capitalize'}}</p>
        </li>
      </ng-template>
      
    </ul>
    <div class="category-header">
      <ng-container *ngIf="!isSymptom; else symptomTitle">
        <h1 class="page-title" *ngIf="!isSymptom">Best {{category | slugText : 'capitalize'}} 
          <ng-container *ngIf="hasCity; else noCityNormal">
            in {{city | slugText : 'capitalize'}}
          </ng-container>
          <ng-template #noCityNormal>
            near you
          </ng-template>
        </h1>
        <p class="page-description">Compare {{totalProviders}} {{category | slugText : 'capitalize'}} providers for booking 
          <ng-container *ngIf="hasCity; else noCityNormal">
            in {{city | slugText : 'capitalize'}}
          </ng-container>
          <ng-template #noCityNormal>
            near you
          </ng-template>
        </p>
      </ng-container>
      <ng-template #symptomTitle>
        <h1 class="page-title" *ngIf="isSymptom">Best Treatments for {{category | slugText : 'capitalize'}} 
          <ng-container *ngIf="hasCity">
            in {{city | slugText : 'capitalize'}}
          </ng-container>
        </h1>
        <p class="page-description">Compare {{totalProviders}} providers that can treat {{category | slugText : 'capitalize'}} for booking 
          <ng-container *ngIf="hasCity; else noCityNormal">
            in {{city | slugText : 'capitalize'}}
          </ng-container>
          <ng-template #noCityNormal>
            near you
          </ng-template>
        </p>
      </ng-template>
      <ul class="related-categories" *ngIf="relatedSubCategories.length > 1">
        <ng-container *ngFor="let subcategory of relatedSubCategories">
          <li [ngClass]="{'active': subcategory.key === category}">
            <ng-container *ngIf="subcategory.key !== category; else norouting">
              <a [routerLink]="'/category/' + (mainCategory || category) +'/' + subcategory.key + '' + (hasCity ? '/' + city : '') + '' + (isSuburbPage ? '/' + post_code : '')">{{subcategory.name}}</a>
            </ng-container>
            <ng-template #norouting>
              <a>{{subcategory.name}}</a>
            </ng-template>
            
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="category-providers-container">
      <div class="category-providers">
        <ng-container *ngFor="let provider of providersList">
          <app-category-provider-item *ngIf="provider?.business_service?.length > 0" [provider]="provider"></app-category-provider-item>
        </ng-container>
      </div>
      <p class="loading" *ngIf="fetchingData"><i class="fa fa-spinner fa-spin"></i> Fetching providers...</p>
      <p class="loading" *ngIf="nodata">No providers available...</p>
      <button class="show-more-btn" *ngIf="pageNumber === 1 && providersList.length > 0 && totalPages > 1" (click)="showAllProviders()">Show all providers</button>
    </div>
    <ng-container *ngIf="!fetchingData">
      <app-category-faq [category]="isSubCategoryPage ? mainCategory : category" [suburb]="hasCity ? getMajorCityForSuburb(true) : ''"></app-category-faq>
      <!-- <app-category-description></app-category-description> -->
      <app-for-category showBlogContent="true" [service]="isSubCategoryPage ? mainCategory : category" [city]="hasCity ? getMajorCityForSuburb(true) : ''"></app-for-category>
      <app-category-other-locations *ngIf="!isSubCategoryPage"></app-category-other-locations>
      <app-category-related-blogs></app-category-related-blogs>
      <div class="recommened-category-container" *ngIf="relatedCategories?.length > 0">
        <h2>People searching for {{(isSubCategoryPage ? mainCategory : category) | slugText : 'capitalize'}} also considered</h2>
        <ul class="related-categories">
          <ng-container *ngFor="let related of relatedCategories">
            <li>
              <a routerLink="{{fetchRelatedUrl(related)}}">{{related | slugText : 'capitalize'}}</a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    
  </div>
</div>